import { call, put, select, takeLatest, fork } from 'redux-saga/effects'

import RootState from '../root-state'
import { auth0Actions } from '../auth0'
import { toastActions } from '../toast'
import { getItemPriceHistories } from '../api'
import { itemPriceHistoryActions, itemPriceHistoryActionType } from './actions'
import { ItemPriceHistoryParam } from './item-price-histories'

function* fetchItemPriceHistories(
  action: ReturnType<typeof itemPriceHistoryActions.fetchItemPriceHistories>
) {
  try {
    yield put(auth0Actions.checkSession())
    const state: RootState = yield select()
    const token = state.auth0.auth.idToken

    const params: ItemPriceHistoryParam = action.payload
    const response = yield call(getItemPriceHistories, token, params)
    const pagination = {
      page: params.page,
      per: params.per,
      total: response.totalCount,
    }
    yield put(
      itemPriceHistoryActions.fetchItemPriceHistoriesSucceeded(
        response.priceHistories,
        pagination
      )
    )
  } catch (error) {
    yield put(itemPriceHistoryActions.throwError(error))
    yield put(
      toastActions.show({
        type: 'error',
        title: '取得に失敗しました',
        body: '価格変更履歴を取得できませんでした',
      })
    )
  }
}

export function* watchFetchItemPriceHistories() {
  yield takeLatest(
    itemPriceHistoryActionType.FETCH_ITEM_PRICE_HISTORIES,
    fetchItemPriceHistories
  )
}

export const itemPriceHistorySagas = [fork(watchFetchItemPriceHistories)]
